import { useState, useCallback } from 'react'
import type { Warehouse } from '../../domain/warehouse'
import { AddWarehouseUseCase } from '../../usecases/CreateWarehouseUseCase'
import { AxiosWarehouseRepository } from '../../infrastructure/AxiosWarehouseRepository'
interface UseAddWarehouseReturn {
    addWarehouse: (
        data: Warehouse,
        onSuccess?: () => void | Promise<void>
    ) => Promise<Warehouse | null>
    loading: boolean
    error: Error | null
    success: boolean
    reset: () => void
}

export const useAddWarehouse = (): UseAddWarehouseReturn => {
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState<Error | null>(null)
    const [success, setSuccess] = useState(false)

    const reset = useCallback(() => {
        setError(null)
        setSuccess(false)
    }, [])

    const addWarehouse = useCallback(
        async (
            data: Warehouse,
            onSuccess?: () => void | Promise<void>
        ): Promise<Warehouse | null> => {
            setLoading(true)
            setError(null)
            setSuccess(false)

            try {
                const repository = new AxiosWarehouseRepository()
                const useCase = new AddWarehouseUseCase(repository)
                const warehouse = await useCase.execute(data)

                setSuccess(true)

                // Ejecutar callback de éxito si se proporciona
                if (onSuccess) {
                    await onSuccess()
                }

                return warehouse
            } catch (err) {
                const errorMessage =
                    err instanceof Error ? err : new Error(String(err))
                setError(errorMessage)
                return null
            } finally {
                setLoading(false)
            }
        },
        []
    )

    return {
        addWarehouse,
        loading,
        error,
        success,
        reset,
    }
}
